import { useNavigate, useLocation } from 'react-router-dom';
const useSetQueryParams = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return (newQuery) => navigate(location.pathname + newQuery);
};
export default useSetQueryParams;
